<template lang="pug">
  .home.main.theme-b(@touchmove='handlePrevent')
    .pendant
      logo
    say
    notice
    login(v-if='isShowLogin')
    scene
    panoVideo
    vIframe
    vArticle
    shareModal(v-if='isShowShare')
</template>

<script>
import say from '@/components/say'
import logo from '@/components/logo'
import login from '@/components/login'
import scene from '@/components/scene'

import notice from '@/components/notice'
import shareModal from '@/components/share'
import panoVideo from '@/components/panoVideo'
import vIframe from '@/components/iframe'
import vArticle from '@/components/article'

import { mapGetters } from 'vuex'

export default {
  name: 'home',
  components: {
    say,
    logo,
    login,
    scene,
    notice,
    shareModal,
    vIframe,
    vArticle,
    panoVideo,
  },
  computed: {
    ...mapGetters(['isShowLogin', 'isShowShare']),
  },
  methods: {
    handlePrevent(ev) {
      // ev.preventDefault()
    },
  },
}
</script>
<style lang="stylus" scoped>
.theme-b
  .pendant
    top: 30px
</style>
